export enum SDDefaultSamplers {
    EULER = "euler",
    EULER_A = "euler a",
    HEUN = "heun",
    DPM_PP_2M_KARRAS = "DPM++ 2M Karras",

    UNI_PC = "UniPC",

}
